// P7 (batch 2): the dashboard's Tasks tile (v1/getUserTasks) shows tasks, events or both. The choice is a
// per-browser convenience (localStorage, guarded: it can be missing or blocked); the default is Both, which is
// what the tile always showed.
export const TASKS_TILE_KINDS = [
  { label: 'Tasks', value: 'TASK' },
  { label: 'Events', value: 'ACTIVITY' },
  { label: 'Both', value: 'BOTH' }
]

const KEY = 'mbp.tasksTileKind'

export function isTasksTileEndpoint (endpoint) {
  return !!endpoint && endpoint.indexOf('v1/getUserTasks') >= 0
}

export function readTasksTileKind (storage = safeStorage()) {
  try {
    const v = storage && storage.getItem(KEY)
    return TASKS_TILE_KINDS.some(k => k.value === v) ? v : 'BOTH'
  } catch (e) {
    return 'BOTH'
  }
}

export function saveTasksTileKind (kind, storage = safeStorage()) {
  try { if (storage) storage.setItem(KEY, kind) } catch (e) { /* not remembered: still applied */ }
}

// The query the tile adds: none for Both, so the request is exactly as before.
export function tasksTileQuery (kind) {
  return kind === 'TASK' || kind === 'ACTIVITY' ? { kind } : {}
}

function safeStorage () {
  try { return window.localStorage } catch (e) { return null }
}
